import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SessionProfileRefreshersStorage {
    public profileRefresher = new Subject<boolean>();

    constructor() { }

    refreshProfile() {
        this.profileRefresher.next(true);
    }

    listenProfileRefresher(): Observable<boolean> {
        return this.profileRefresher.asObservable();
    }
}